export default __webpack_public_path__ + "static/media/ea-hero.8ecc3df8.svg";